<!--
  Le compte à rebours d'une autorisation d'exploitation.

  C'est la colonne vertébrale du module : la règle de la spec est que l'échéance
  prime toujours sur le volume — cinq mètres cubes à sortir demain passent devant
  six cents dans deux mois. Elle mérite donc sa propre forme, et trois cas que le
  reste du module confondait :
    - une échéance dépassée (nombre négatif, à dire en clair) ;
    - une échéance absente (un APV dont SUMAL ne donne pas de date) ;
    - un permis PERMANENT — les dépôts fixes portent 01-01-2100, une sentinelle.
      La décompter afficherait « dans 27 000 jours » en tête de liste.
-->
<template>
  <span class="hv2-deadline" :class="`is-${tone}`">
    <template v-if="tone === 'none'">
      <span class="hv2-deadline-n">{{ permanent ? 'permanent' : '—' }}</span>
    </template>
    <template v-else>
      <span class="hv2-deadline-n">{{ Math.abs(days) }}</span>
      <span class="hv2-deadline-u">{{ unitLabel }}</span>
    </template>
    <span v-if="showDate && date" class="hv2-deadline-date">{{ date }}</span>
  </span>
</template>

<script>
import { deadlineTone } from '../format'

export default {
  name: 'HvDeadline',
  props: {
    days: { type: Number, default: null },
    date: { type: String, default: '' },
    permanent: { type: Boolean, default: false },
    showDate: { type: Boolean, default: false }
  },
  computed: {
    tone () { return deadlineTone(this.days, this.permanent) },
    unitLabel () {
      if (this.days === null) return ''
      return this.days < 0 ? (Math.abs(this.days) > 1 ? 'j de retard' : 'j de retard') : 'j'
    }
  }
}
</script>
